import React from 'react';
import PropTypes from 'prop-types';
import { useSprings, useSpring, a } from '@react-spring/web';

const SuccessMessageAnimation = ({ isValid, children }) => {
  const items = React.Children.toArray(children);
  const springs = useSprings(
    items.length,
    items.map((item, i) => ({
      from: {
        opacity: 0,
        y: 0,
        position: 'relative',
        visibility: 'hidden'
      },
      to: {
        opacity: 1,
        y: -30,
        position: 'relative',
        visibility: 'visible',
        textAlign: 'center'
      },
      delay: !isValid ? 1500 + 250 + 50 * i : 250 + 50 * i,
      reset: !isValid,
      reverse: isValid
    }))
  );

  const springContainer = useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    delay: !isValid ? 1500 : 0,
    reset: !isValid,
    reverse: isValid
  });

  const elements = springs.map((styles, index) => (
    <a.div key={index} style={styles}>
      {items[index]}
    </a.div>
  ));

  return <a.div style={springContainer}>{elements}</a.div>;
};

SuccessMessageAnimation.propTypes = {
  isValid: PropTypes.bool.isRequired,
  children: PropTypes.array.isRequired
};

export default SuccessMessageAnimation;
